import { Component } from '@angular/core';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  lang: any = localStorage.getItem('currentlang');
  isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 1024px)').matches) || screen.width <= 1024

  constructor(private eventService: EventService) {
    this.eventService.getLang().subscribe((val) => {
      this.lang = val || 'en';
    });
   }
}
